import { CommonService } from '../../services';

const getUser = (data) => {
  const response = {};

  Object.values(data).forEach((el) => {
    if (el.questionID === 12) response.FullName = el.value;
    if (el.questionID === 13) response.LastName = el.value;
    if (el.questionID === 24) response.EMail = el.value;
  });

  return response;
};

export const submitMenteeForm = async (
  answers,
  setSaving,
  setSuccess,
  isReview
) => {
  setSaving(true);
  try {
    const user = getUser(answers);
    const {
      message,
      response: { ID },
    } = await CommonService.saveUser(user, 'Mentees');
    const responses = Object.values(answers).map((el) => {
      return {
        userid: String(ID),
        userLastName: user.LastName,
        userFirstNamel: user.FullName,
        ...el,
      };
    });
    if (message === 'User already exists' && !isReview) {
      console.error('Member already submitted form');
      return;
    }
    await CommonService.saveResponses(responses, 'MenteeResponse');
    setSuccess(true);
  } catch (e) {
    console.error(e);
  } finally {
    setSaving(false);
  }
};
